'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');

var fetchMoreData = function (pageNumber, pageSize, fetchMore) { return tslib.__awaiter(void 0, void 0, void 0, function () {
    var newRows, hasMore;
    return tslib.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchMore(pageNumber, pageSize)];
            case 1:
                newRows = (_a.sent()).data;
                hasMore = newRows.length === pageSize;
                return [2 /*return*/, {
                        totalPages: hasMore ? pageNumber + 1 : pageNumber,
                        data: newRows,
                    }];
        }
    });
}); };

exports.fetchMoreData = fetchMoreData;
